import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate, useParams, useSearchParams } from 'libs/router'
import { queryKeys } from 'config/queryKeys'
import { apiRoutes } from 'config/apiRoutes'
import { routes } from 'config/routes'
import axios from 'libs/fetch'
import { FieldValues, UseFormSetError } from 'libs/form'
import { setApiFieldErrors } from 'utils/formErrors'

export const useEditProductMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const navigate = useNavigate()
	const params = useParams()
	const [searchParams] = useSearchParams()

	const { mutate: editProductMutation, isPending: isEditProductMutationLoading } = useMutation({
		mutationFn: (data: FormData) => {
			return axiosPrivate.patch(apiRoutes.product(params.id as string), data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Product edited')
			})()

			navigate(
				searchParams.toString() ? `/products?${searchParams.toString()}` : routes.productIndex
			)
		},
		onError: (error) => {
			if (axios.isAxiosError(error)) {
				if (error.response?.status === 400) setApiFieldErrors(setError, error.response.data)

				for (const [_key, value] of Object.entries(error?.response?.data)) {
					useToast({
						type: 'error',
						message: t(value as string)
					})()
				}

				return
			}
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		editProductMutation,
		isEditProductMutationLoading
	}
}
